export const MODAL_ACTION = 'MODAL_ACTION';

export const onModal = (name, open) => {
    return {type: MODAL_ACTION, name, open};
};




// WEBPACK FOOTER //
// ./src/actions/ModalActions.js